

import React from "react";
import Lottie from "lottie-react";
import notfound from "../../assests/Animation.json"; // Ensure the path is correct
import Layout from "../Layout/Layout";

const NotFound = () => {
  return (
    <Layout>
       <h2 style={{ textTransform: "capitalize" }} className="px-5 mt-5">
                  No Result Found
                </h2>
    
    <div className="d-flex justify-content-center">
      <Lottie animationData={notfound} loop={true} />
    </div>
  </Layout>
 
  );
};

export default NotFound;
